type IdleWindow = Window & {
  requestIdleCallback?: (
    callback: () => void,
    options?: { timeout?: number },
  ) => number;
  cancelIdleCallback?: (handle: number) => void;
};

export function scheduleAfterFirstPaint(
  callback: () => void,
  idleTimeoutMs = 1200,
) {
  let cancelled = false;
  let loadHandler: (() => void) | undefined;
  let firstFrame = 0;
  let secondFrame = 0;
  let fallbackTimer = 0;
  let idleCallbackId: number | undefined;

  const runWhenIdle = () => {
    if (cancelled) return;

    const idleWindow = window as IdleWindow;
    if (idleWindow.requestIdleCallback) {
      idleCallbackId = idleWindow.requestIdleCallback(
        () => {
          if (!cancelled) callback();
        },
        { timeout: idleTimeoutMs },
      );
      return;
    }

    fallbackTimer = window.setTimeout(() => {
      if (!cancelled) callback();
    }, 1000);
  };

  const waitForPaint = () => {
    firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(runWhenIdle);
    });
  };

  if (document.readyState === 'complete') {
    waitForPaint();
  } else {
    loadHandler = waitForPaint;
    window.addEventListener('load', loadHandler, { once: true });
  }

  return () => {
    cancelled = true;
    if (loadHandler) window.removeEventListener('load', loadHandler);
    window.cancelAnimationFrame(firstFrame);
    window.cancelAnimationFrame(secondFrame);
    window.clearTimeout(fallbackTimer);

    const idleWindow = window as IdleWindow;
    if (idleCallbackId !== undefined) {
      idleWindow.cancelIdleCallback?.(idleCallbackId);
    }
  };
}